import { j as o } from "./AccesRecoveryIcon-CUPieIxT.js";
const r = () => /* @__PURE__ */ o.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ o.jsx(
  "path",
  {
    d: "M19.98 5.99a1 1 0 0 0-.687.303L9 16.586l-3.293-3.293a1 1 0 1 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l11-11a1 1 0 0 0-.727-1.717",
    fill: "currentColor"
  }
) });
export {
  r as C
};
